import React from 'react';
import './style.scss';

const Loader = () => {
  return (
    <div className="spinner__container">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
